import apiService from './apiService';
import { RUNTIME_CONFIG_API } from '../../Constants';

const runtimeConfigApi = {
  fetchMetadata: () => apiService.get(RUNTIME_CONFIG_API),

  fetchDocument: (configId) => apiService.get(`${RUNTIME_CONFIG_API}/${configId}`),

  applyChange: ({ configId, operation, author, entry }) =>
    apiService.post(RUNTIME_CONFIG_API, { configId, operation, author, entry }),
};

export default runtimeConfigApi;
